import { useLocation, useNavigate } from "react-router-dom";
import { Spiner } from "@components/loaders/spiner";
import { Bills, DaftarZiswaf } from "@services/dtos/finance.dto";
import { FinanceService } from "@services/finance.service";
import { useThemeStore } from "@stores/theme.store";
import { useMutation, useQuery } from "@tanstack/react-query";
import { formatValue, toRp } from "@utils/helper";
import { Button, Form, Input, message, Select } from "antd";
import { useEffect, useState } from "react";
import moment from "moment";
import lodash from "lodash";
import { FcFinePrint } from "react-icons/fc";
import { SchoolService } from "@services/school.service";
import {
  PopupCustom,
  PopupError,
  PopupSuccess,
} from "@components/general/popup";
import { linkPage } from "@utils/router";

export const RequestVaPage = () => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const { setHeader, setBottomNavigation, setAppBar } = useThemeStore(
    (state) => state
  );
  const [messageApi, contextHolder] = message.useMessage();
  const [form] = Form.useForm();
  // const [nominalSpp, setNominalSpp] = useState<number>(0);
  const [valUangSaku, setValUangSaku] = useState<string>("");
  const [tipeVa, setTipeVa] = useState<string>("");
  const [showMessage, setShowMessage] = useState<boolean>(false);
  const [showMessageText, setShowMessageText] = useState<string>("");
  const [popupPayment, setPopupPayment] = useState<boolean>(false);
  const [popupSuccess, setPopupSuccess] = useState<boolean>(false);
  const [popupError, setPopupError] = useState<boolean>(false);
  const [result, setResult] = useState<any>({});
  const [adminFee] = useState<number>(2000);
  const [bills, setBills] = useState<
    { id: string; notes: string; amount: number; tempo: Date; jenis: string }[]
  >([]);
  const [idxDisabledPayment, setIdxDisabledPayment] = useState<
    { index: number; id: string; amount: number }[]
  >([]);
  const [billZiswaf, setBillZiswaf] = useState<
    {
      id: string;
      keterangan: string;
      nominal: number;
      batasWaktu: Date;
      mode: string;
      opsi: string;
      qty: number;
    }[]
  >([]);

  const { data: dataNis } = useQuery({
    queryKey: [SchoolService.queries.GET_SCHOOL_STUDENT_BIO],
    queryFn: SchoolService.studentBio,
  });
  const nis = dataNis?.data?.nis ?? "";

  const { data, isPending } = useQuery({
    queryKey: [FinanceService.queries.GET_FINANCE_BILLS_PAID_OF, nis],
    queryFn: () => FinanceService.billsPaidOf({ nis }),
  });

  const { data: dataZiswaf, isPending: isPendingZis } = useQuery({
    queryKey: [FinanceService.queries.GET_FINANCE_ZIS],
    queryFn: () => FinanceService.ziswafList(),
  });

  const dataBIlls = data?.data?.filter((item) => item.jenis === state.tipe);

  const { mutate: mutateVA, isPending: isPendingPaymentVa } = useMutation({
    mutationFn: FinanceService.virtualAccountRequest,
    onSuccess: (response) => {
      if (response.success) {
        setResult(response.data);
        setPopupPayment(false);
        setPopupSuccess(true);
      } else {
        setPopupPayment(false);
        setPopupError(true);
      }
    },
    onError: (error: any) => {
      setShowMessage(true);
      setShowMessageText(error.message ?? "Internal Error");
    },
  });

  const { mutate: mutateZiswafVA, isPending: isPendingPaymentZiswafVa } =
    useMutation({
      mutationFn: FinanceService.virtualAccountRequestZiswaf,
      onSuccess: (response) => {
        if (response.success) {
          setResult(response.data);
          setPopupPayment(false);
          setPopupSuccess(true);
        } else {
          setPopupPayment(false);
          setPopupError(true);
        }
      },
      onError: (error: any) => {
        setShowMessage(true);
        setShowMessageText(error.message ?? "Internal Error");
      },
    });

  const [nominalNonSpp, setNominalNonSpp] = useState(
    (data?.data ?? []).length !== 0
      ? Array(
          data?.data?.length
          // data?.data?.filter((item) => item.jenis === "sekali").length
        ).fill("")
      : []
  );

  useEffect(() => {
    setAppBar({ title: "Transaksi", show: true, leading: "back" });
    setHeader({
      buttonBack: true,
      filter: false,
      title: "Transaksi",
    });
    setBottomNavigation(state.tagihan ? "hidden" : "home");
  }, [setHeader, setBottomNavigation, setAppBar]);

  const onPayment = () => {
    if (bills.length < 1 && valUangSaku === "" && state.tipe !== "zis") {
      setShowMessage(true);
      // if (!state.tagihan && state.tipe === "") {
      //   setShowMessageText("Isi nominal uang saku");
      // } else {
      setShowMessageText("Isi minimal 1 pembayaran");
      // }
      return;
    }
    if (billZiswaf.length < 1 && state.tipe === "zis") {
      setShowMessage(true);
      setShowMessageText("Isi minimal 1 pembayaran");
      return;
    }
    if (tipeVa === "") {
      setShowMessage(true);
      setShowMessageText("Pilih rekening Bank terlebih dahulu");
      return;
    }
    if (parseInt(valUangSaku.replace(/\./g, "")) < 10000) {
      setShowMessage(true);
      setShowMessageText("Topup Uang Saku minimal Rp. 10.000");
      return;
    }
    setPopupPayment(true);
  };

  const onConfirmPayment = () => {
    if (state.tipe === "zis") {
      mutateZiswafVA({
        nis: nis,
        data_ziswaf: billZiswaf.map((item) => ({
          id_ziswaf: item.id,
          nominal: item.nominal,
          qty: item.qty,
        })),
      });
    } else {
      mutateVA({
        nis: nis,
        uangsakumasuk:
          valUangSaku === "" ? "0" : valUangSaku.replace(/\./g, ""),
        data: bills.map((item) => ({
          id_tagihan: item.id,
          tagihan: item.notes,
          dibayar: item.amount.toString(),
        })),
      });
    }
    // setPopupPayment(false);
    // setPopupSuccess(true);
  };

  const onChangeBill = (val: string, bill: Bills) => {
    const current = bills.filter(
      (item) => item.id !== bill.nourut
      // && moment(bill.jatuhTempo).isAfter(item.tempo)
    );

    if (bill.jenis === "bulanan") {
      onDisabledPayment(val, bill.nourut, bill.tipe);
    }

    if (val === "") {
      bill.jenis === "bulanan"
        ? onDisabledPayment(val, bill.nourut, bill.tipe)
        : setBills(current);

      return;
    }

    setBills(
      current.concat({
        id: bill.nourut,
        notes: `${bill.tagihan} - ${bill.tahunAjaran}`,
        amount: parseInt(val),
        tempo: moment(bill.jatuhTempo).toDate(),
        jenis: bill.jenis,
      })
    );
  };

  const onChangeBillZiswaf = (val: string, dataZiswaf: DaftarZiswaf) => {
    let nominal = 0;
    let qty = 0;
    const current = billZiswaf.filter((item) => item.id !== dataZiswaf.id);

    if (val === "") {
      setBillZiswaf(current);
      return;
    }

    if (dataZiswaf.opsi === "OPTIONAL") {
      nominal += parseInt(val) * dataZiswaf.nominal;
      qty += parseInt(val);
    } else {
      nominal += parseInt(val);
      qty = 1;
    }

    setBillZiswaf(
      current.concat({
        id: dataZiswaf.id,
        keterangan: dataZiswaf.keterangan,
        nominal: nominal,
        batasWaktu: moment(dataZiswaf.batasWaktu, "YYYY-MM-DD").toDate(),
        mode: dataZiswaf.mode,
        opsi: dataZiswaf.opsi,
        qty: qty,
      })
    );
  };

  const checkData =
    data?.data
      ?.filter((item) => item.jenis === "bulanan")
      .map((item, index) => ({
        index: index,
        id: item.nourut,
        amount: item.nominal,
      })) ?? [];

  const onDisabledPayment = (val: string, nourut: string, tipe: string) => {
    const nourutIndex = checkData.findIndex((item) => item.id === nourut);
    if (
      val !== "" &&
      nourutIndex !== -1 &&
      nourutIndex < checkData.length - 1
    ) {
      const dataDisabled = [...idxDisabledPayment, checkData[nourutIndex + 1]];
      const uniqueElements = lodash.uniqBy(dataDisabled, "id");

      setIdxDisabledPayment(uniqueElements);
    } else if (val === "" || val === null || val === undefined) {
      const updatedData = idxDisabledPayment.filter(
        (item) => item.index <= nourutIndex
      );
      const billsIndex = bills.findIndex((item) => item.id === nourut);

      if (billsIndex !== -1 && billsIndex < bills.length) {
        const updatedBills = bills.filter((item, index) => {
          return index < billsIndex || !(item.jenis === "bulanan");
        });
        setBills(updatedBills);
      }
      setIdxDisabledPayment(updatedData);
    }
  };

  const checkFirstIndexArr = (nourut: string) => {
    const currentArr = data?.data?.filter((item) => item.jenis === "bulanan");
    return (
      currentArr && currentArr.length > 0 && currentArr[0].nourut === nourut
    );
  };

  useEffect(() => {
    if (checkData.length > 0) {
      setIdxDisabledPayment([
        {
          index: checkData[0].index,
          id: checkData[0].id,
          amount: checkData[0].amount,
        },
      ]);
    }
  }, [data]);

  useEffect(() => {
    if (showMessage) {
      messageApi.open({
        type: "warning",
        content: <>{showMessageText}</>,
      });
    }
    setShowMessage(false);
  }, [showMessage, showMessageText]);

  return (
    <>
      {contextHolder}
      <div className="tw-px-4 tw-pb-20">
        <div className="">
          <div id="tab-item">
            <Form
              form={form}
              className="tw-mb-4"
              name="basic"
              layout="vertical"
            >
              {state.tagihan && (
                <>
                  {/* tagihan */}
                  <div
                    className="tw-rounded-lg tw-bg-other-100"
                    style={{
                      boxShadow: "0 0.125rem 0.25rem rgba(0, 0, 0, 0.075)",
                    }}
                  >
                    {isPending ? (
                      <div className="tw-p-6 tw-text-center">
                        <Spiner />
                      </div>
                    ) : dataBIlls != null && dataBIlls.length > 0 ? (
                      dataBIlls
                        // .filter((item) => item.jenis === "bulanan")
                        .map((item, idx) => (
                          <div
                            key={idx}
                            className="tw-border-0 tw-border-b tw-border-solid tw-border-other-300"
                          >
                            <div className="tw-px-2 tw-py-1">
                              <div className="tw-p-2 tw-pb-0 tw-flex tw-justify-between tw-text-xs tw-text-other-600">
                                <span
                                  style={{
                                    overflowWrap: "break-word",
                                    whiteSpace: "nowrap",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    maxWidth: "65%",
                                  }}
                                >
                                  {item.tagihan} - {item.tahunAjaran}
                                </span>
                                <div className="tw-text-xs">Bayar (Rp.)</div>
                              </div>
                              <div className="tw-p-2 tw-pt-1 tw-flex tw-justify-between tw-items-end tw-font-bold tw-text-other-600">
                                <span className="tw-text-xs">
                                  {toRp(item.nominal)}
                                </span>
                                <Form.Item name="bayarspp" className="tw-mb-0">
                                  <div className="tw-text-other-600">
                                    {state.tipe === "bulanan" ? (
                                      <Input
                                        style={{ width: "90%", float: "right" }}
                                        className="tw-text-right"
                                        inputMode="numeric"
                                        pattern="[0-9]*"
                                        type="text"
                                        // value={
                                        //   idxDisabledPayment.some(
                                        //     (disabledItem) =>
                                        //       disabledItem.id === item.nourut
                                        //   )
                                        //     ? formatValue(
                                        //         (
                                        //           bills.find(
                                        //             (i) => i.id === item.nourut
                                        //           )?.amount ?? ""
                                        //         )
                                        //           ?.toString()
                                        //           .replace(/\D/g, "")
                                        //       )
                                        //     : ""
                                        // }
                                        // onClick={(e) => {
                                        //   const input =
                                        //     e.target as HTMLInputElement;
                                        //   const value = item.nominal
                                        //     .toString()
                                        //     .replace(/\D/g, "");

                                        //   input.value =
                                        //     input.value === ""
                                        //       ? formatValue(
                                        //           item.nominal
                                        //             .toString()
                                        //             .replace(/\D/g, "")
                                        //         )
                                        //       : "";

                                        //   onChangeBill(
                                        //     input.value
                                        //       .toString()
                                        //       .replace(/\D/g, ""),
                                        //     item
                                        //   );
                                        // }}
                                        // onKeyDown={(event) => {
                                        //   if (
                                        //     !/[0-9]|Backspace|Tab/.test(
                                        //       event.key
                                        //     )
                                        //   ) {
                                        //     event.preventDefault();
                                        //   }
                                        // }}
                                        // disabled={
                                        //   (checkFirstIndexArr(item.nourut) &&
                                        //     idxDisabledPayment.length === 0) ||
                                        //   idxDisabledPayment.some(
                                        //     (disabledItem) =>
                                        //       disabledItem.id === item.nourut
                                        //   )
                                        //     ? false
                                        //     : true
                                        // }
                                        // readOnly
                                        value={nominalNonSpp[idx]}
                                        onInput={(e) => {
                                          const input =
                                            e.target as HTMLInputElement;
                                          const raw = input.value.replace(
                                            /\D/g,
                                            ""
                                          );
                                          const clampedValue = Math.min(
                                            parseInt(raw || "0"),
                                            item.nominal
                                          );
                                          const formatted = formatValue(
                                            clampedValue.toString()
                                          );

                                          setNominalNonSpp((prevValues) => {
                                            const newValues = [...prevValues];
                                            newValues[idx] = formatted;
                                            return newValues;
                                          });
                                          onChangeBill(
                                            clampedValue.toString(),
                                            item
                                          );
                                        }}
                                        onBlur={(e) => {
                                          const input =
                                            e.target as HTMLInputElement;
                                          const raw = input.value.replace(
                                            /\D/g,
                                            ""
                                          );
                                          const clampedValue = Math.min(
                                            parseInt(raw || "0"),
                                            item.nominal
                                          );
                                          const formatted = formatValue(
                                            clampedValue.toString()
                                          );
                                          // const formatted =
                                          //   parseInt(raw) >= item.nominal
                                          //     ? toRp(item.nominal).slice(4)
                                          //     : formatValue(raw);

                                          setNominalNonSpp((prevValues) => {
                                            const newValues = [...prevValues];
                                            newValues[idx] = formatted;
                                            return newValues;
                                          });
                                        }}
                                        onKeyDown={(event) => {
                                          if (
                                            !/[0-9]|Backspace|Tab/.test(
                                              event.key
                                            )
                                          ) {
                                            event.preventDefault();
                                          }
                                        }}
                                      />
                                    ) : state.tipe === "sekali" ||
                                      state.tipe === "utang" ? (
                                      <Input
                                        style={{ width: "90%", float: "right" }}
                                        className="tw-text-right"
                                        inputMode="numeric"
                                        pattern="[0-9]*"
                                        type="text"
                                        value={nominalNonSpp[idx]}
                                        onInput={(e) => {
                                          const input =
                                            e.target as HTMLInputElement;
                                          const raw = input.value.replace(
                                            /\D/g,
                                            ""
                                          );
                                          const clampedValue = Math.min(
                                            parseInt(raw || "0"),
                                            item.nominal
                                          );
                                          const formatted = formatValue(
                                            clampedValue.toString()
                                          );

                                          setNominalNonSpp((prevValues) => {
                                            const newValues = [...prevValues];
                                            newValues[idx] = formatted;
                                            return newValues;
                                          });
                                          onChangeBill(
                                            clampedValue.toString(),
                                            item
                                          );
                                        }}
                                        onBlur={(e) => {
                                          const input =
                                            e.target as HTMLInputElement;
                                          const raw = input.value.replace(
                                            /\D/g,
                                            ""
                                          );
                                          const clampedValue = Math.min(
                                            parseInt(raw || "0"),
                                            item.nominal
                                          );
                                          const formatted = formatValue(
                                            clampedValue.toString()
                                          );
                                          // const formatted =
                                          //   parseInt(raw) >= item.nominal
                                          //     ? toRp(item.nominal).slice(4)
                                          //     : formatValue(raw);

                                          setNominalNonSpp((prevValues) => {
                                            const newValues = [...prevValues];
                                            newValues[idx] = formatted;
                                            return newValues;
                                          });
                                        }}
                                        onKeyDown={(event) => {
                                          if (
                                            !/[0-9]|Backspace|Tab/.test(
                                              event.key
                                            )
                                          ) {
                                            event.preventDefault();
                                          }
                                        }}
                                      />
                                    ) : null}
                                  </div>
                                </Form.Item>
                              </div>
                            </div>
                          </div>
                        ))
                    ) : (
                      <div className="tw-p-8 tw-text-center ">
                        <FcFinePrint size={50} />
                        <div>Tidak ada tagihan</div>
                      </div>
                    )}
                  </div>

                  {/* uang saku */}
                  <div
                    className="tw-mt-4 tw-mb-2 tw-rounded-lg card"
                    style={{
                      boxShadow: "0 0.125rem 0.25rem rgba(0, 0, 0, 0.075)",
                    }}
                  >
                    <div className="tw-px-2 tw-py-1">
                      <div className="tw-p-2 tw-pb-0 tw-flex tw-justify-between tw-text-xs tw-text-other-600">
                        <span>Uang Saku</span>
                      </div>
                      <div className="tw-p-2 tw-pt-1 tw-flex tw-justify-between tw-items-end tw-font-bold tw-text-other-600">
                        <span className="tw-text-xs">(ketik nominal)</span>
                        <Form.Item name="uangsaku" className="tw-mb-0">
                          <Input
                            style={{ width: "90%", float: "right" }}
                            className="tw-text-end"
                            inputMode="numeric"
                            type="text"
                            onChange={(e) => {
                              const value = e.target.value.replace(/\D/g, "");
                              const formattedValue = formatValue(value);
                              form.setFieldsValue({ uangsaku: formattedValue });
                              setValUangSaku(
                                value === "" ? "" : formattedValue
                              );
                            }}
                            onKeyDown={(event) => {
                              if (!/[0-9]|Backspace|Tab/.test(event.key)) {
                                event.preventDefault();
                              }
                            }}
                            value={valUangSaku}
                          />
                        </Form.Item>
                      </div>
                    </div>
                  </div>
                </>
              )}

              {!state.tagihan && state.tipe === "zis" && (
                <div
                  className="tw-mt-4 tw-rounded-lg tw-bg-other-100"
                  style={{
                    boxShadow: "0 0.125rem 0.25rem rgba(0, 0, 0, 0.075)",
                  }}
                >
                  {isPendingZis ? (
                    <div className="tw-p-6 tw-text-center">
                      <Spiner />
                    </div>
                  ) : dataZiswaf?.data != null && dataZiswaf.data.length > 0 ? (
                    dataZiswaf.data.map(
                      (item, idx) =>
                        item.batasWaktu === "" ||
                        (item.batasWaktu !== "" &&
                          moment().format("YYYY-MM-DD") <=
                            moment(item.batasWaktu).format("YYYY-MM-DD") && (
                            <div
                              key={idx}
                              className="tw-border-0 tw-border-b tw-border-solid tw-border-other-300"
                            >
                              <div className="tw-px-2 tw-py-1">
                                <div className="tw-p-2 tw-pb-0 tw-flex tw-justify-between tw-text-xs tw-text-other-600">
                                  <span
                                    style={{
                                      overflowWrap: "break-word",
                                      whiteSpace: "nowrap",
                                      overflow: "hidden",
                                      textOverflow: "ellipsis",
                                      maxWidth: "65%",
                                    }}
                                  >
                                    {item.keterangan}
                                  </span>
                                  <div className="tw-text-xs">Bayar (Rp.)</div>
                                </div>
                                <div className="tw-p-2 tw-pt-1 tw-flex tw-justify-between tw-items-end tw-font-bold tw-text-other-600">
                                  <span className="tw-text-xs">
                                    {item.nominal.toString() === "0"
                                      ? "ketik nominal"
                                      : toRp(item.nominal)}
                                  </span>
                                  <Form.Item
                                    name="bayarspp"
                                    className="tw-mb-0"
                                  >
                                    <div className="tw-text-other-600">
                                      {item.nominal.toString() === "0" ? (
                                        <Input
                                          style={{
                                            width: "90%",
                                            float: "right",
                                          }}
                                          className="tw-text-right"
                                          inputMode="numeric"
                                          pattern="[0-9]*"
                                          type="text"
                                          value={nominalNonSpp[idx]}
                                          onInput={(e) => {
                                            const input =
                                              e.target as HTMLInputElement;
                                            const raw = input.value.replace(
                                              /\D/g,
                                              ""
                                            );
                                            const formatted = formatValue(
                                              raw.toString()
                                            );

                                            setNominalNonSpp((prevValues) => {
                                              const newValues = [...prevValues];
                                              newValues[idx] = formatted;
                                              return newValues;
                                            });
                                            onChangeBillZiswaf(raw, item);
                                          }}
                                          onBlur={(e) => {
                                            const input =
                                              e.target as HTMLInputElement;
                                            const raw = input.value.replace(
                                              /\D/g,
                                              ""
                                            );

                                            const formatted = formatValue(
                                              raw.toString()
                                            );

                                            setNominalNonSpp((prevValues) => {
                                              const newValues = [...prevValues];
                                              newValues[idx] = formatted;
                                              return newValues;
                                            });
                                          }}
                                          onKeyDown={(event) => {
                                            if (
                                              !/[0-9]|Backspace|Tab/.test(
                                                event.key
                                              )
                                            ) {
                                              event.preventDefault();
                                            }
                                          }}
                                        />
                                      ) : (
                                        <Input
                                          style={{
                                            width: "90%",
                                            float: "right",
                                          }}
                                          className="tw-text-right"
                                          inputMode="numeric"
                                          pattern="[0-9]*"
                                          type="text"
                                          value={formatValue(
                                            (
                                              billZiswaf.find(
                                                (i) => i.id === item.id
                                              )?.nominal ?? ""
                                            )
                                              ?.toString()
                                              .replace(/\D/g, "")
                                          )}
                                          onClick={(e) => {
                                            const input =
                                              e.target as HTMLInputElement;
                                            const value = item.nominal
                                              .toString()
                                              .replace(/\D/g, "");

                                            input.value =
                                              input.value === ""
                                                ? formatValue(
                                                    item.nominal
                                                      .toString()
                                                      .replace(/\D/g, "")
                                                  )
                                                : "";

                                            onChangeBillZiswaf(
                                              input.value
                                                .toString()
                                                .replace(/\D/g, ""),
                                              item
                                            );
                                          }}
                                          onKeyDown={(event) => {
                                            if (
                                              !/[0-9]|Backspace|Tab/.test(
                                                event.key
                                              )
                                            ) {
                                              event.preventDefault();
                                            }
                                          }}
                                          readOnly
                                        />
                                      )}
                                    </div>
                                  </Form.Item>
                                </div>
                              </div>
                            </div>
                          ))
                    )
                  ) : (
                    <div className="tw-p-8 tw-text-center ">
                      <FcFinePrint size={50} />
                      <div>Tidak ada ZIS</div>
                    </div>
                  )}
                </div>
              )}

              <div className="tw-bg-other-100 tw-rounded-lg tw-mt-4 card-body">
                <div className="tw-mb-2 tw-text-xs tw-text-other-600">
                  Pilih Bank
                </div>
                <Select
                  className="tw-w-full"
                  value={tipeVa}
                  options={[
                    { value: "", label: "pilih bank", disabled: true },
                    { value: "BSM", label: "BSM/BSI" },
                  ]}
                  onChange={(newValue) => {
                    setTipeVa(newValue);
                  }}
                />
              </div>
              <div className="tw-bg-other-100 tw-rounded-lg tw-mt-4 card-body">
                <Button
                  type="primary"
                  loading={isPendingPaymentVa}
                  className="tw-h-9 tw-w-full bg-gradient focus:tw-shadow-none hover:tw-bg-other-100 hover:tw-text-primary-hg hover:tw-border-primary-hg"
                  onClick={onPayment}
                >
                  Lakukan Pembayaran
                </Button>
              </div>
            </Form>
          </div>
        </div>
      </div>

      <PopupCustom
        open={popupPayment}
        title="Konfirmasi Pembayaran"
        onCancel={() => setPopupPayment(false)}
      >
        <>
          {valUangSaku !== "" ? (
            <>
              <div className="tw-my-3 divider"></div>
              <div className="tw-font-bold tw-mt-2 tw-mb-1">Uang Saku</div>
              <div className="tw-flex">
                <div className="tw-grow">Uang Saku</div>
                <div>
                  {valUangSaku === ""
                    ? toRp(0)
                    : toRp(parseInt(valUangSaku.replace(/\D/g, "")))}
                </div>
              </div>
            </>
          ) : null}

          {bills.length > 0 ? (
            <>
              <div className="tw-my-3 divider"></div>
              <div className="tw-font-bold tw-mt-2 tw-mb-1">Tagihan</div>
              {bills.map((item, idx) => (
                <div key={idx} className="tw-flex tw-justify-between tw-mb-0.5">
                  <div className="tw-grow" style={{ maxWidth: "50%" }}>
                    {item.notes}
                  </div>
                  <div>{toRp(item.amount)}</div>
                </div>
              ))}
            </>
          ) : billZiswaf.length > 0 ? (
            <>
              <div className="tw-my-3 divider"></div>
              <div className="tw-font-bold tw-mt-2 tw-mb-1">Pembayaran</div>
              {billZiswaf.map((item, idx) => (
                <div key={idx} className="tw-flex tw-justify-between tw-mb-0.5">
                  <div className="tw-grow" style={{ maxWidth: "50%" }}>
                    {item.keterangan}
                  </div>
                  <div>{toRp(item.nominal)}</div>
                </div>
              ))}
            </>
          ) : null}
          <div className="tw-my-3 divider"></div>
          <div className="tw-flex">
            <div className="tw-grow">Subtotal</div>
            <div>
              {toRp(
                bills.map((i) => i.amount).reduce((a, b) => a + b, 0) +
                  (valUangSaku === ""
                    ? 0
                    : parseInt(valUangSaku.replace(/\D/g, ""))) +
                  billZiswaf.map((i) => i.nominal).reduce((a, b) => a + b, 0)
              )}
            </div>
          </div>
          <div className="tw-flex">
            <div className="tw-grow">Biaya Admin</div>
            <div>{toRp(adminFee)}</div>
          </div>
          <div className="tw-flex tw-mt-2">
            <div className="tw-grow tw-font-bold">Total</div>
            <div className="tw-font-bold">
              {toRp(
                bills.map((i) => i.amount).reduce((a, b) => a + b, 0) +
                  adminFee +
                  (valUangSaku === ""
                    ? 0
                    : parseInt(valUangSaku.replace(/\D/g, ""))) +
                  billZiswaf.map((i) => i.nominal).reduce((a, b) => a + b, 0)
              )}
            </div>
          </div>
          <div className="tw-my-3 divider"></div>
          <Button
            type="primary"
            loading={isPendingPaymentVa}
            className="tw-h-9 tw-w-full bg-gradient focus:tw-shadow-none hover:tw-bg-other-100 hover:tw-text-primary-hg hover:tw-border-primary-hg"
            onClick={onConfirmPayment}
          >
            Konfirmasi Bayar (
            {toRp(
              bills.map((i) => i.amount).reduce((a, b) => a + b, 0) +
                adminFee +
                (valUangSaku === ""
                  ? 0
                  : parseInt(valUangSaku.replace(/\D/g, ""))) +
                billZiswaf.map((i) => i.nominal).reduce((a, b) => a + b, 0)
            )}
            )
          </Button>
        </>
      </PopupCustom>

      <PopupSuccess
        open={popupSuccess}
        title="Berhasil!"
        message="Permintaan Virtual Account (VA) Berhasil!"
        textConfirm="Lihat Detail"
        onConfirm={() =>
          navigate(linkPage.VA_DETAIL_PAGE, {
            replace: true,
            state: {
              vaBankFee: adminFee,
              vaBankName: tipeVa,
              vaDateExpired: result.datetime_expired,
              vaDatePayment: null,
              vaName: result.customer_name,
              vaNumber: result.virtual_account,
              vaStatus: "PENDING",
              vaTrxAmount: parseInt(result.trx_amount),
              vaTrxId: result.trx_id,
              // type: rekening?.type,
            },
          })
        }
      />

      <PopupError
        open={popupError}
        title="Gagal!"
        message="selesaikan transaksi sebelumnya terlebih dahulu"
        textConfirm="Cek Transaksi"
        onConfirm={() => navigate(linkPage.VA_DATA_PAGE)}
      />
    </>
  );
};
